import * as React from "react";
import "moment/locale/fr";
import Page from "src/presentations/views/PageView";
import { RouteComponentProps, useParams } from "react-router-dom";
import { defaults } from "react-chartjs-2";
import { multipleQueries } from "src/utils/graph/GraphExplorer";
import { register } from "timeago.js";
import { localeENFunc } from "src/utils/timeago";
import withSession from "src/utils/withSession";
import * as SC from "../../companies/Company_styled";
import Scrollbars from "react-custom-scrollbars";
import DeleteModal from "src/presentations/widgets/DeleteModal";
import { toast } from "react-toastify";
import Loader from "src/presentations/widgets/Loader";
import { translate } from "src/utils/translate";
register("en", localeENFunc);
defaults.global.defaultFontFamily = "Gelion";
import Text from "src/presentations/elements/Text";
import { useHistory, useLocation } from "react-router-dom";
import i18n from "src/assets/messages";
import styled from "styled-components";
import { Calendar, CloudRain, Database, Trash2 } from "react-feather";
import Table from "src/presentations/collections/Table/Columns";
import { IUserCompany } from "src/pages/companies/createCompany";
import { parse } from "query-string";
import * as moment from 'moment';
import { Storage } from 'src/utils/storage';

export type Cell = string | number | undefined;

const StyledTable = styled.div`
  .table-simple td {
    vertical-align: middle !important;
    padding: 5px 10px !important;
    border-bottom: 1px solid #fff;
  }
`;

export interface Row {
  statusCode: number;
  value: string;
  type: string;
}
interface PropsInterface extends RouteComponentProps<{}> {
  session: any;
}

export interface IcompaniesRows {
  name: string;
  description: string;
  task: string;
  logoURL: string;
  color: string;
  id: string;
  companyUsers: IUserCompany[];
}

interface ItransactionsRows {
  id: string,
  label: string,
  amount: number,
  date: string
}

const Bank = (props: PropsInterface) => {
  const { search } = useLocation();

  const [showModal, setshowModal] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [companiesRows, setBanks] = React.useState<IcompaniesRows[]>([]);
  const [transactions, setTransactions] = React.useState<ItransactionsRows[]>([]);
  const { push, location } = useHistory();
  const queryURL = new URLSearchParams(search);
  const [ready] = React.useState(true);
  const { companyId }: any = useParams();
  const [pages, setPage] = React.useState(
    Number(queryURL.get("page")) ? Number(queryURL.get("page")) : 1
  );
  const [deleteId, setDeleteId] = React.useState("");
  const [countBank, setCountBank] = React.useState(0)
  const language = Storage.get('language')

  const paramsDefault = {
    noDataIndication: i18n.t("resultEmptyExtenxion"),
    containerClass: "table-simple table-simple-raw",
    bordered: false,
    striped: false,
    hover: false,
    rowClasses: "listRow",
  };

  React.useEffect(() => {
    document.title = `Bank`;
    getData();
  }, [pages]);

  const getData = async () => {
    setLoading(true);
    const prms: any = parse(location.search);

    let offset;
    if (prms.page) {
      offset = ((prms.page || 1) - 1) * 30;
    }

    const resultBanks: any = await multipleQueries([
      {
        type: "findAll",
        target: "Bank",
        alias: "rows",
        where: { companyId },
        offset,
        limit: 30,
        output: {
          id: true,
          name: true,
          powensId: true,
          original_name: true,
          createdAt: true,
          iban: true,
          bic: true,
          balance: true,
          number: true
        },
      },
      {
        type: "count",
        where: { companyId },
        target: "Bank",
        alias: "countBank",
      },
    ]);

    const result: any = await multipleQueries([
      {
        type: "findAll",
        target: "transactions",
        alias: "transactions",
        order: [['date', 'DESC']],
        where: {
          companyId,
          date_gte: moment().subtract(30, 'days').startOf('day').toISOString(),
          date_lte: moment().endOf('day').toISOString(),
        },
        output: {
            id: true,
            bankId: true,
            label: true,
            amount: true,
            date: true
        },
    },
    ]);

    for (let i = 0; i < resultBanks.rows.length; i++) {
      const resultLastTransaction: any = await multipleQueries([
          {
            type: "findAll",
            target: "transactions",
            alias: "transactions",
            limit: 1,
            order: [['date', 'DESC']],
            where: {
              companyId, bankId: resultBanks.rows[i].id
            },
            output: {
                id: true,
                date: true
            },
        },
      ]);

      if (resultLastTransaction && resultLastTransaction.transactions && resultLastTransaction.transactions.length) {
        resultBanks.rows[i].lastDate = resultLastTransaction.transactions[0].date;
      }
      
    }

    const DateObj = new Date(result.createdAt);
    DateObj.setDate(DateObj.getDate() + 15);
    setBanks(resultBanks.rows);
    setCountBank(resultBanks.countBank);
    setLoading(false);
    setTransactions(result.transactions)
  };

  const handlePageChange: any = (pageNumber: number) => {
    const currentUrlParams = new URLSearchParams(location.search);
    if (pageNumber) {
      currentUrlParams.set("page", pageNumber.toString());
      setPage(Number(pageNumber));
      push(location.pathname + "?" + currentUrlParams.toString());
    }
  };

  const deleteModal = async () => {
    setshowModal(false);
    await getData();
    toast(translate(language, "Company deleted!"), { autoClose: 2000 });
  };

  const getFormatData = (TRANSACTIONS: any, DTSTART: any, DTEND: any, BANKID: any, GUICHET: any, ACCOUNTID: any, BALANCEEND: any) => {
    const DTSERVER = Math.floor(Date.now() / 1000);
    const CURRDATE = new Date().toISOString().slice(0, 10).replace(/-/g, '');
    
    const response = `OFXHEADER:100
DATA:OFXSGML
VERSION:102
SECURITY:NONE
ENCODING:USASCII
CHARSET:1252
COMPRESSION:NONE
OLDFILEUID:NONE
NEWFILEUID:NONE
<OFX>
<SIGNONMSGSRSV1>
<SONRS>
<STATUS>
<CODE>0
<SEVERITY>INFO
</STATUS>
<DTSERVER>${DTSERVER}
<LANGUAGE>FRA
</SONRS>
</SIGNONMSGSRSV1>
<BANKMSGSRSV1>
<STMTTRNRS>
<TRNUID>00
<STATUS>
<CODE>0
<SEVERITY>INFO
</STATUS>
<STMTRS>
<CURDEF>EUR
<BANKACCTFROM>
<BANKID>${BANKID}
<BRANCHID>${GUICHET}
<ACCTID>${ACCOUNTID}
<ACCTTYPE>CHECKING
</BANKACCTFROM>
<BANKTRANLIST>
<DTSTART>${DTSTART}
<DTEND>${DTEND}
${TRANSACTIONS}
</BANKTRANLIST>
<LEDGERBAL>
<BALAMT>${BALANCEEND}
<DTASOF>${CURRDATE}
</LEDGERBAL>
<AVAILBAL>
<BALAMT>${BALANCEEND}
<DTASOF>${CURRDATE}
</AVAILBAL>
</STMTRS>
</STMTTRNRS>
</BANKMSGSRSV1>
</OFX>
`;
    return response;
}

 const generateNumericString = (length: number) =>  {
  let result = '';
  const characters = '0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    result += characters.charAt(randomIndex);
  }
  return result;
}

const getTransaction = (change: any, date: any, amount: any, libelle: any, memo: any)  =>{
  date = date.substr(4) + date.substr(0, 4);
  const idTrans = generateNumericString(39)
  const transaction = `<STMTTRN>
<TRNTYPE>${change}
<DTPOSTED>${date}
<TRNAMT>${amount}
<FITID>${idTrans}
<NAME>${libelle}
<MEMO>${libelle}
</STMTTRN>`;
  return transaction;
}


  const columnsModels = () => [
    {
      dataField: "name",
      text: translate(language, "Nom du compte"),
      headerStyle: { width: "20%" },
      formatter: (cell: any, row: any) => {
        if (cell) {
          return (
            <Text useWordBoundary={50} trucanteType="middle" text={cell} />
          );
        }
        return <></>;
      },
    },
    {
      dataField: "iban",
      text: translate(language, "IBAN"),
      headerStyle: { width: "15%" },
      formatter: (cell: any, row: any) => {
        if (cell) {
          return (
            <span>{cell}</span>
          );
        }
        return <></>;
      },
    },
    {
      dataField: "balance",
      text: translate(language, "Solde"),
      headerStyle: { width: "7%", textAlign: "right" },
      formatter: (cell: any, row: any) => {
        return (
          <div style={{ textAlign: "right" }}>
            {`${cell.toLocaleString('fr-FR', {
              style: 'currency',
              currency: 'EUR',
            })}`}
          </div>
        );
      },
    },
    {
      dataField: "lastDate",
      text: translate(language, "Synchronisation"),
      headerStyle: { width: "10%" },
      formatter: (cell: any, row: any) => {
          if (cell) {
            return (
              <span>
                  <Calendar size={15} style={{verticalAlign: "sub", marginRight: "10px" }} />
                  {`${moment(new Date(cell))
                      .locale(language)
                      .format("DD/MM/YYYY")}`}
              </span>
          );
          }

          return <></>
      },
    },
    {
      dataField: "id",
      text: "",
      headerStyle: { width: "13%" },
      formatter: (cell: Cell, row: any) => {
        return (
          <a
            onClick={() => {

              let TRANSACTIONS = ''
              transactions
              .filter((transaction: any) => transaction.bankId === cell)
              .map((transaction) => {
                TRANSACTIONS += getTransaction(
                  transaction.amount > 0 ? "CREDIT" : "DEBIT",
                  new Date(transaction.date).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, ''),
                  transaction.amount,
                  transaction.label,
                  transaction.label
                )
              })


              const cT = transactions.filter((transaction: any) => transaction.bankId === cell)
              const BALANCEEND = row.balance || 0;
              const DTSTART = new Date(cT[0].date).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '');
              const DTEND = new Date(cT[cT.length - 1].date).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '');

              let iban: string = row.iban;
              iban = iban.replace(' ', '');
              let BANKID = iban.substring(4, 9);
              let GUICHET = iban.substring(9, 14);
              let ACCOUNTID = iban.substring(14, 25);

              BANKID = String(BANKID).padStart(5, '0');
              GUICHET = String(GUICHET).padStart(5, '0');
              ACCOUNTID = String(ACCOUNTID).padStart(11, '0');
              const ofxContent = getFormatData(TRANSACTIONS, DTSTART, DTEND, BANKID, GUICHET, ACCOUNTID, BALANCEEND);

              const blob = new Blob([ofxContent], { type: 'application/octet-stream' });
              const url = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = `${row.name}.ofx`;
              link.click();
              URL.revokeObjectURL(url);
            }}
          >
            <CloudRain size="15" style={{ verticalAlign: "sub", marginRight: 5 }} />
            <Text useWordBoundary={20} trucanteType="middle">
              {translate(language, "OFX M-1")}
            </Text>
          </a>
        );
      },
    },
    {
      dataField: "",
      text: "",
      headerStyle: { width: "10%" },
      formatter: (cell: Cell, row: any) => {
        return (
          <a
            onClick={() =>
              push(`/${language}/companies/${companyId}/banks/${row.id}`)
            }
          >
            <Database size="15" style={{ verticalAlign: "sub", marginRight: 5 }} />
            <Text useWordBoundary={20} trucanteType="middle">
              {translate(language, "Détails")}
            </Text>
          </a>
        );
      },
    },
    {
        dataField: 'number',
        text: '',
        headerStyle: { width: '20%' },
        formatter: (cell: Cell, row: any) => {
          return (
            <a onClick={() => {
              setshowModal(true)
              setDeleteId(row.id)
            }}>
              <Trash2 size="15" />
            </a>
          )
        }
      }
  ];

  return (
    <SC.StyleCompany>
      <div className="companyWrap" style={{ paddingTop: 15 }}>
        <DeleteModal
          show={showModal}
          onHide={() => setshowModal(false)}
          target="Company"
          id={deleteId}
          onComfirm={deleteModal}
        />
        <div
          className="well"
          style={{
            marginBottom: "30px",
            marginLeft: "30px",
            marginRight: "30px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="total-data">Total Banks:{countBank}</span>
        </div>
        <Page.Content>
          {loading && (
            <Loader textLabel={translate(language, "Chargement des comptes bancaires")} />
          )}
          {!loading && (
            <Scrollbars
              style={{ height: "calc(100vh - 175px)", width: "calc(100% )" }}
              autoHide={true}
            >
              <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                <StyledTable>
                  <Table
                    {...paramsDefault}
                    ready={ready}
                    loading={loading}
                    datas={companiesRows || []}
                    columns={columnsModels() as any}
                    selectColumn={false}
                    pagination={{
                      page: pages,
                      sizePerPage: 30,
                      onPageChange: handlePageChange,
                      alwaysShowAllBtns: false,
                    }}
                    totalSize={countBank}
                    striped={true}
                    noDataIndication={translate(
                      language,
                      "No requests available"
                    )}
                    hover={true}
                  />
                </StyledTable>
              </div>
            </Scrollbars>
          )}
        </Page.Content>
      </div>
    </SC.StyleCompany>
  );
};

export default withSession(Bank);



// WEBPACK FOOTER //
// ./src/pages/company/bank/index.tsx